import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'EN' | 'FR';
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (en: string, fr: string) => string;
}
const STORAGE_KEY = 'bciti-lang';
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
function getInitialLang(): Language {
  if (typeof window === 'undefined') return 'EN';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === 'FR' || stored === 'EN' ? stored : 'EN';
}
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLangState] = useState<Language>(getInitialLang);
  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore write failures (e.g. private mode)
    }
  }, [lang]);
  const setLang = (next: Language) => setLangState(next);
  const t = (en: string, fr: string) => lang === 'FR' ? fr : en;
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-487">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}